import { InjectionToken } from "@angular/core";

export interface RonMonitorPollingConfig {
  boardMs: number;
  detailMs: number;
}

export const RON_MONITOR_POLLING = new InjectionToken<RonMonitorPollingConfig>(
  "RON_MONITOR_POLLING",
  {
    factory: () => ({ boardMs: 180_000, detailMs: 60_000 }),
  }
);
